var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("csp-table", {
    attrs: {
      icon: "inticon-autoclaim_company",
      "items-ajax-url": _vm.itemsAjaxUrl,
      "table-headline": "Zugeordnete Autohäuser",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }